<template>
  <!-- Layout for event - gaming -->
  <div class="game-layout">
    <RouterView />
  </div>
</template>
<script>
export default {
  name: 'Game',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.game-layout{
  display: block;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #ececec;
  background: linear-gradient(to bottom, #222 0%,#141414 100%);
}
@media only screen and (max-width: 1439.98px) {}
@media only screen and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
</style>
